textarea.form-control(data-filter-id=filterId placeholder='Enter values separated by commas or line breaks' data-type=filter.type rows=10 disabled=!isEditable) #{filter.valuesList}
.row
    .col-md-6
        .checkbox
            label
                input(type="checkbox" checked=filter.isSensitive disabled=!isEditable)
                | Sensitive information
        .small.help-block You may want to use this for personal information, such as email addresses or phone numbers.
